import config from '../misc/Configuracao';
import { MovimentoCNJ, Processo } from '../modelo';
import { MinutaMovimentos, MovimentoBasicoDTO, MovimentoComplementoDto } from '../modelo/MinutaMovimentos';
import fetch from './AxiosAdapter';

class MovimentoApi {

    async recuperarTodosLegadoPJe(): Promise<MovimentoBasicoDTO[]> {
        const result = await fetch<MovimentoBasicoDTO[]>(config.urlMovimentoProcessualLegadoPJe, {
            timeout: 30000
        });
        return result.data;
    }

    async gravar(minutasMovimentos: MinutaMovimentos[]) {
        return await fetch(config.urlMovimentosMinuta, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: minutasMovimentos
        });
    }

    async recuperarMovimentosMinutas(processos: Processo[]): Promise<MinutaMovimentos[]> {
        const result = await fetch<MinutaMovimentos[]>(config.urlMovimentosMinuta + '/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            data: processos.map(p => p.identificadorProcesso)
        });

        const map = result.data;
        const retorno = []
        const numMinutas = Object.keys(map)
        numMinutas.forEach(nm => {
            retorno.push ({
                numMinuta:parseInt(nm),
                movimentos:map[nm]
            })
        })
        return retorno;
    }

    async recuperarMovimentosMinutasComIdentificadorProcesso(identificadorProcesso): Promise<MinutaMovimentos[]> {
        const result = await fetch<MinutaMovimentos[]>(config.urlMovimentosMinuta + '/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            data: [identificadorProcesso]
        });

        return result.data;
    }

    async recuperarOpcoesDeComplementos(processo: Processo, codigoMovimentoCNJ: string): Promise<MovimentoComplementoDto[]> {

        const result = await fetch<MovimentoComplementoDto[]>(config.urlOpcoesDeComplementoDeMovimentoDeProcesso
            .replace('{COD_MOVIMENTO}', codigoMovimentoCNJ)
            .replace('{ID_PROCESSO}', processo?.identificadorProcesso?.toString() || null)
        );
        return result.data;
    }


}

export default new MovimentoApi();